import {
  Col,
  Form,
  Modal,
  Row,
  Select,
  Divider,
  DatePicker,
  Button,
} from "antd";
import React from "react";
import { debounce } from "lodash";
import service from "./service";

class OfferManagementFilterModal extends React.Component {
  state = {
    memberList: [],
    revisionList: [],
    searchLoading: false,
    selectedCountry: [],
    selectCountryText: "",

    createdDate1: null,
    createdDate2: null,
    updatedDate1: null,
    updatedDate2: null,

    resetted: false,
  };

  componentDidUpdate() {
    const { reset, cbReset } = this.props;

    if (reset) {
      this.handleOnResetFilter();
      cbReset();
    }
  }

  handleOnSubmit = () => {
    const { countryList, submit, onClose } = this.props;
    const dateKeys = [
      "expired_start",
      "expired_end",
      "created_start",
      "created_end",
    ];
    this.props.form.validateFields((err, values) => {
      if (err) {
        return;
      }

      // ? filtering only the key that has value
      const keys = Object.keys(values);
      const payload = {};
      for (const key of keys) {
        if (!values[key]) {
          continue;
        }
        payload[key] = values[key];

        if (dateKeys.includes(key)) {
          const currentDateKey = key.split("_")[0];
          const start = `${currentDateKey}_start`;
          const end = `${currentDateKey}_end`;
          if (payload[start] && !payload[end]) {
            payload[currentDateKey] =
              payload[start].format("YYYY-MM-DD") +
              ":" +
              payload[start].format("YYYY-MM-DD");
          }

          if (values[end] && !values[start]) {
            payload[currentDateKey] =
              values[end].format("YYYY-MM-DD") +
              ":" +
              values[end].format("YYYY-MM-DD");
          }

          if (values[start] && values[end]) {
            payload[currentDateKey] =
              values[start].format("YYYY-MM-DD") +
              ":" +
              values[end].format("YYYY-MM-DD");
          }
        }
      }

      // ? delete all unused key
      for (const unusedKey of dateKeys) {
        delete payload[unusedKey];
      }

      // ? check selected_country
      if (this.state.selectedCountry.length > 0) {
        const countries = this.state.selectedCountry;
        const regionCodesArray = countries.map((c) => {
          const findCountry = countryList.find((item) => item.name === c);
          return `'${findCountry.region_code}'`;
        });
        payload["counties"] = regionCodesArray.join(",");
      }

      // const parsed = JSON.stringify(payload);
      submit(payload);
      onClose();
    });
  };

  handleOnSearchMember = async (input) => {
    this.setState({
      searchLoading: true,
    });
    // ? check if input is null
    let res = [];
    if (input !== "") {
      res = await service.searchMemberList(input);
    }

    this.setState({
      searchLoading: false,
      memberList: res,
    });
  };

  handleOnSelectCountry = (v) => {
    const { countryList } = this.props;

    const hasCountry = countryList.find((item) => item.region_code === v);
    if (!hasCountry) {
      return;
    }

    const tempSeleted = this.state.selectedCountry;
    const isDuplicated = tempSeleted.includes(hasCountry.name);
    if (isDuplicated) {
      return;
    }

    tempSeleted.push(hasCountry.name);
    this.setState({
      selectedCountry: tempSeleted,
      selectCountryText: v,
    });
  };

  handleOnResetcountry = () => {
    this.setState({
      selectedCountry: [],
      selectCountryText: "",
    });
  };

  handleOnResetFilter = () => {
    this.props.form.resetFields();
    this.handleOnResetcountry();
  };

  triggerOnChangeMutipleSelect = (v) => {
    this.setState({
      selectedCountry: v,
    });
  };

  render() {
    const { visible, onClose, revisionList, countryList } = this.props;
    const { getFieldDecorator } = this.props.form;
    return (
      <Modal
        title="Custom Filter"
        visible={visible}
        onCancel={onClose}
        width={800}
        className="custom-filter"
        footer={
          <div style={{ textAlign: "center" }}>
            <Button onClick={() => this.handleOnSubmit()} type="primary">
              OK
            </Button>
            <Button onClick={onClose}>Cancel</Button>
          </div>
        }
      >
        <Form>
          <Row gutter={12}>
            <Col span={4} style={{ textAlign: "end" }}>
              <Form.Item>
                <span>Customer</span>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="member_id">
                {getFieldDecorator("member_id")(
                  <Select
                    allowClear
                    showSearch
                    placeholder="Select Customer"
                    optionFilterProp="children"
                    //? delay input by using debouce for 0.6 second
                    onSearch={debounce(this.handleOnSearchMember, 600)}
                    loading={this.state.searchLoading}
                  >
                    {this.state.memberList.map((item, i) => (
                      <Select.Option key={i} value={item.id}>
                        {item.firstname + " " + item.lastname}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col span={4} style={{ textAlign: "end" }}>
              <Form.Item>
                <span>Revision</span>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="revision_id">
                {getFieldDecorator("revision_id")(
                  <Select
                    allowClear
                    showSearch
                    placeholder="Select Revision"
                    optionFilterProp="children"
                  >
                    {revisionList.map((item, i) => (
                      <Select.Option key={i} value={item.id}>
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>

          <Divider style={{ margin: "12px" }} />

          <Row gutter={8} type="flex">
            <Col span={4} style={{ textAlign: "end" }}>
              <Form.Item>
                <span>Country</span>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item>
                <Select
                  allowClear
                  showSearch
                  placeholder="Select Country"
                  onChange={(v) => this.handleOnSelectCountry(v)}
                  value={this.state.selectCountryText}
                >
                  {countryList.map((item, i) => (
                    <Select.Option key={i} value={item.region_code}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col>
              <Form.Item>
                <span
                  style={{ textDecoration: "underline" }}
                  className="touchable"
                  onClick={() => this.handleOnResetcountry()}
                >
                  Reset
                </span>
              </Form.Item>
            </Col>
            <Col span={20} offset={4}>
              <Form.Item>
                <Select
                  mode="multiple"
                  optionLabelProp="label"
                  open={false}
                  value={this.state.selectedCountry}
                  onChange={(v) => this.triggerOnChangeMutipleSelect(v)}
                />
              </Form.Item>
            </Col>
          </Row>

          <Divider style={{ margin: "12px" }} />
          <Row gutter={12} type="flex">
            <Col span={4} style={{ textAlign: "end" }}>
              <Form.Item>
                <span>Created Date</span>
              </Form.Item>
            </Col>
            <Col style={{ textAlign: "end" }}>
              <Form.Item>
                <span>From</span>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="created_start">
                {getFieldDecorator("created_start")(
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={(c) => {
                      if (this.state.createdDate2) {
                        return c > this.state.createdDate2;
                      }
                      return;
                    }}
                    onChange={(d) => this.setState({ createdDate1: d })}
                  />
                )}
              </Form.Item>
            </Col>
            <Col style={{ textAlign: "end" }}>
              <Form.Item>
                <span>To</span>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="created_end">
                {getFieldDecorator("created_end")(
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={(c) => {
                      if (this.state.createdDate1) {
                        return c <= this.state.createdDate1;
                      }
                      return;
                    }}
                    onChange={(d) => this.setState({ createdDate2: d })}
                  />
                )}
              </Form.Item>
            </Col>
          </Row>

          <Divider style={{ margin: "12px" }} />
          <Row gutter={12} type="flex">
            <Col span={4} style={{ textAlign: "end" }}>
              <Form.Item>
                <span>Expire Date</span>
              </Form.Item>
            </Col>
            <Col style={{ textAlign: "end" }}>
              <Form.Item>
                <span>From</span>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="expired_start">
                {getFieldDecorator("expired_start")(
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={(c) => {
                      if (this.state.updatedDate2) {
                        return c > this.state.updatedDate2;
                      }
                      return;
                    }}
                    onChange={(d) => this.setState({ updatedDate1: d })}
                  />
                )}
              </Form.Item>
            </Col>
            <Col style={{ textAlign: "end" }}>
              <Form.Item>
                <span>To</span>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="expired_end">
                {getFieldDecorator("expired_end")(
                  <DatePicker
                    style={{ width: "100%" }}
                    disabledDate={(c) => {
                      if (this.state.updatedDate1) {
                        return c <= this.state.updatedDate1;
                      }
                      return;
                    }}
                    onChange={(d) => this.setState({ updatedDate2: d })}
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default Form.create({ name: "offer-management-filters" })(
  OfferManagementFilterModal
);



// WEBPACK FOOTER //
// ./src/containers/OfferManagement/modalFilter.js